export default "__VITE_ASSET__5879b0ac__"